import HeadingText1 from "components/HeadingText/HeadingText1";
import React from "react";

const AboutUsInfo = () => {
  return (
    <div className="nc-AboutUsInfo container flex flex-col justify-center text-center">
      <HeadingText1 className="text-csccolor pt-8 pb-4 sm:pt-10">
        About Us
      </HeadingText1>
      <div className="flex justify-center px-4">
        <p className="leading-6 sm:leading-8 max-w-4xl">
          Founded in 2005 under the name Earth-line SSL, CSC LED has grown into
          a trusted name in commercial and industrial lighting across Canada. As
          a proudly Canadian-owned and operated company, we specialize in
          providing high-performance, competitively priced LED lighting
          solutions exclusively to electrical wholesalers. Our products are
          built using premium components, including top-grade LED chips,
          reliable drivers, and proven thermal management systems, ensuring
          consistent performance and longevity. What truly sets us apart is our
          commitment to support: we offer responsive technical assistance and
          dedicated customer service to help our partners succeed. For over 20
          years, we’ve built lasting relationships in the industry by standing
          behind every product we sell, helping Canadians light their spaces
          with confidence, quality, and value.
        </p>
      </div>
    </div>
  );
};

export default AboutUsInfo;
